import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { THEMES } from '../../../../data/product/product.data';
import { ProductLine } from '../../../../model/product/product.model';

/**
 * Private Pinterest-pin gallery.
 *
 * This page is NOT linked from the nav or sitemap and ships `noindex` (see
 * scripts/seo-route-meta.js), it exists so the Codigrate team can capture
 * ready-made pins for Pinterest. It is a thin shell that renders one
 * `<app-pinterest-card>` per theme; the card owns the entire pin design.
 *
 * Capture mode: with `?only=<product-key>` the page renders just that one
 * theme's pin, so a screenshot tool can grab a clean, full pin per theme
 * (no neighbours, no lazy-load shifts).
 */
@Component( {
  selector: 'app-pinterest-page',
  templateUrl: './pinterest-page.component.html',
  styleUrls: [ './pinterest-page.component.scss' ],
} )
export class PinterestPageComponent {

  /** Theme product lines, iterated in the template. */
  themes: ProductLine[] = THEMES;

  /** When set (via `?only=`), only this product's pin is rendered. */
  onlyKey: string | null;

  constructor( route: ActivatedRoute ) {
    this.onlyKey = route.snapshot.queryParamMap.get( 'only' );
  }

  /** trackBy for the product-line *ngFor. */
  trackByLineKey( _index: number, line: ProductLine ): string {
    return line.key;
  }

  /** trackBy for the product *ngFor (product key is unique per render). */
  trackByProductKey( _index: number, product: { key: string } ): string {
    return product.key;
  }
}
